import moment from "moment"

export default (context) => {
  let years = []
  let year = 2018
  const currentYear = parseInt(moment().format('Y'))
  while (year <= currentYear) {
    years.push({ value: year, label: year.toString() })
    year++
  }
  return {
      config: {
        pageSize: 40,
        list: false,
        customPathGet: "admBilling/getGrid",
        customPathPost: "admBilling/createbulk"
        // customPathPost: "admOrder/createbulk"
      },
    
      actions: {
        create: false,
        edit: false,
        delete: false,
        print: true,
        export: true,
        search: true
      },

      extras: {
        itemsInRowsTable: [
          { icon: 'simple-icon-eye', name: 'Ver ordenes', onClick: (rowData, ctx) => {
              let obj = {
                module: 'admOrder',
                params: [
                  {
                    name: "studentId",
                    value: {value: rowData.ID, label: (rowData.name) },
                    type: "select",
                    label: "Alumno",
                    opts: {
                      style: 'float-label',
                      searchOnline: true,
                      path: "/admStudent/get?pick=true",
                      withImg: true
                    }
                  },
                ],
                type: 0,
                keepFilters: false
              }
              ctx.props.setDeeplink(obj, ctx.props.history)
            }
          },
          { icon: 'simple-icon-eye',  name: 'Ver pagos', onClick: (rowData, ctx) => {
              console.log(rowData)
              let obj = {
                module: 'admBilling',
                params: [
                  {
                    name: "studentId",
                    value: {value: rowData.ID, label: (rowData.name) },
                    type: "select",
                    label: "Alumno",
                    opts: {
                      style: 'float-label',
                      searchOnline: true,
                      path: "/admStudent/get?pick=true",
                      withImg: true
                    }
                  },
                ],
                type: 0,
                keepFilters: false
              }
              ctx.props.setDeeplink(obj, ctx.props.history)
            }
          }
        ]
      },

      filter: {
        fields: [
          {
            name: "year",
            value: currentYear,
            type: "select",
            label: "Año",
            opts: {
              style: 'float-label',
              items: years
            }
          },
          {
            name: "sectionId",
            value: "",
            type: "select",
            label: "Sección",
            opts: {
              style: 'float-label',
              searchOnline: true,
              path: "/admSection/get?pick=true"
            }
          }
        ],
        buttons: [
          {
            label: 'Aplicar filtro',
            renderIf: (ctx) => { return Number.isInteger(ctx.state.year) && ctx.state.name !== "" },
            onClick: (ctx) => { ctx.btnAction('filter') }
          }
        ]
      },

      form: {
        fields: []
      },

      columns: [
        {
          Header: "ID Alumno",
          accessor: "ID"
        },
        {
          Header: "Nombre",
          accessor: "name"
        },
        {
          Header: "Grado / Sección",
          accessor: "sectionTag"
        },
        {
          Header: "ID Externo",
          accessor: "externalId"
        },
        {
          Header: "1",
          accessor: "M1",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "2",
          accessor: "M2",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "3",
          accessor: "M3",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "4",
          accessor: "M4",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "5",
          accessor: "M5",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "6",
          accessor: "M6",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "7",
          accessor: "M7",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "8",
          accessor: "M8",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "9",
          accessor: "M9",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "10",
          accessor: "M10",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "11",
          accessor: "M11",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "12",
          accessor: "M12",
          isDecimal: true,
          minWidth: 50
        },
        {
          Header: "Beca",
          accessor: "condition",
          isBool: true,
          minWidth: 50
        }
      ]
  }
}